module.exports = __webpack_public_path__ + "static/media/overlay-desktop.992bf14d.png";